import React, { useState } from "react";
import {
  MobileNavItem,
  MobileNavParentText,
  MobileNavSubItem,
  MobileNavSubMenu,
} from "../../constants/component.constants";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Collapse } from "@mui/material";
import Permit from "../../util/permit";
import { NavLink } from "react-router-dom";

export default function MobileParentMenuItem({ item, closeDrawer }) {
  const [open, setOpen] = useState(false);

  function toggleMenu(e) {
    setOpen(!open);
  }

  function closeSubMenu(e) {
    setOpen(false);
    closeDrawer();
  }

  return (
    <Permit
        roles={item.roles}
        services={item.services}
        permissions={item.permissions}
        key={item.id}
    >
      <MobileNavItem id="dropDownTrigger" onClick={toggleMenu}>
        <MobileNavParentText
          primary={item.name}
          primaryTypographyProps={{ color: "#fff" }}
        />
        {open ? <ExpandLess /> : <ExpandMore />}
      </MobileNavItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <MobileNavSubMenu
          component="div"
          sx={{
            backgroundColor: "white",
            borderRadius: "10px",
          }}
        >
          {item.children &&
            item.children.map((child, i) => (
                <Permit
                  key={i}
                  roles={child.roles}
                  services={child.services}
                  permissions={child.permissions}
                >
                  <MobileNavSubItem
                    key={i}
                    onClick={closeSubMenu}
                    component={NavLink}
                    to={child.href}
                  >
                    {child.name}
                  </MobileNavSubItem>
                </Permit>
            ))}
        </MobileNavSubMenu>
      </Collapse>
    </Permit>
  )
}
